module.exports = __webpack_public_path__ + "img/icon-card.e268878a.svg";